import { useRef } from "react"
import { Box, HStack, Stack } from "@chakra-ui/react"

import { NavBar, Navigation, Toaster } from "@/components"
import { useAuth, useViewer } from "@/contexts"
import { useClientDeals } from "@/hooks"
import { PortalRole } from "@/types"
import { Outlet } from "react-router-dom"


export const ClientLayout = () => {
  const { user, loading } = useAuth()
  const { clientId, isImpersonating } = useViewer()
  console.log("ClientLayout clientId:", clientId)
  const { data: clientDeals, isLoading } = useClientDeals()
  const sectionRef = useRef<HTMLDivElement>(null)

  if (loading) return <div>Loading...</div>
  if (!user) return <div>Unauthorized</div>
  
  const canViewClientDashboard =
    user.userType === PortalRole.CLIENT || user.userType === PortalRole.ESO_PERSON

  if (!canViewClientDashboard) return <div>Unauthorized</div>

  return (
    <>
      <HStack w="100%" h="100vh" gap={0}>
        <Box w="20vw" h="100%">
          <Navigation
            dealManager={user.userType === PortalRole.ESO_PERSON ? user : undefined}
            deals={clientDeals || []}
          />
        </Box>

        <Stack w="80vw" h="100%" gap={0}>
          <NavBar deals={clientDeals || []} isImpersonating={isImpersonating} />
          <Stack ref={sectionRef} bg="page.bg" w="100%" overflowY="scroll">
            <Outlet context={{ deals: clientDeals, isLoading }} />
          </Stack>
        </Stack>
      </HStack>
      <Toaster />
    </>
  )
}